import React from 'react';
import moment from 'moment';
import propTypes from 'prop-types';
import commonMessage from 'src/utils/commonMessage.json';

//mui material
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Chip,
  Box,
  Typography,
  Icon,
  IconButton,
  Button,
  Popover,
} from '@mui/material';
import { styled } from '@mui/material/styles';

//components
import NetworkError from 'src/components/Error/networkError';
import { CustomSkeleton } from '../../skeleton/skeletonLoader';
import Tooltip from '@mui/material/Tooltip';

import { nameFormater } from 'src/utils/common';

import InfoIcon from '@mui/icons-material/Info';
// import gLogin from './gLogo.png';

// Show table filtes.
const TableFilterSection = styled('div')(() => ({
  width: 'auto',
  padding: '16px 16px 16px 16px',
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
}));

export const PaginationTable = ({
  TtsContentJsx,
  RouteJsx,
  AudioPlayerJsx,
  page = 0,
  tableFilter,
  ActionJsx,
  ActionModals,
  setPage,
  rowsPerPage = 10,
  setRowsPerPage,
  setLoad,
  count = 0,
  error = false,
  loading,
  setLoading,
  rows,
  columns,
  size = 'small',
  calculatedHeight = 0,
  PttsContentJsx,
}) => {
  const handleChangePage = (e, newPage) => {
    setPage(newPage);
    setLoad(true);
    setLoading(true);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    setLoad(true);
    setLoading(true);
  };

  const dateFormatJsx = (id, align, value) => {
    const date = moment(value * 1000);
    const formattedDate = date.format('D MMM, YYYY');

    return (
      <TableCell
        key={id}
        align={align}
        sx={{
          color: 'grey.700',
          borderBottom: '0.5px dashed',
          borderColor: 'grey.300',
        }}
      >
        <>
          <Box>{formattedDate}</Box>
        </>
      </TableCell>
    );
  };

  const roleFormatJsx = (id, align, value) => {
    const roleFormatMapper = {
      superAdmin: 'Super-Admin',
      admin: 'Admin',
      agent: 'Agent',
    };

    return (
      <TableCell
        key={id}
        align={align}
        sx={{
          color: 'grey.700',
          borderBottom: '0.5px dashed',
          borderColor: 'grey.300',
        }}
      >
        {roleFormatMapper[value]}
      </TableCell>
    );
  };

  const defaultRowJsx = (id, align, value) => (
    <TableCell
      key={id}
      align={align}
      sx={{
        color: 'grey.700',
        borderBottom: '0.5px dashed',
        borderColor: 'grey.300',
      }}
    >
      {value || '--'}
    </TableCell>
  );

  const userTypeJsx = (id, align, value) => (
    <TableCell
      key={id}
      align={align}
      sx={{
        color: 'grey.700',
        borderBottom: '0.5px dashed',
        borderColor: 'grey.300',
      }}
    >
      {nameFormater(value || '--')}
    </TableCell>
  );

  const usedModuleJsx = (id, align, value, row) => {
    return (
      <TableCell
        key={id}
        align={align}
        sx={{
          color: 'grey.700',
          borderBottom: '0.5px dashed',
          borderColor: 'grey.300',
        }}
      >
        <Tooltip title={value}>
          <IconButton>
            <InfoIcon />
          </IconButton>
        </Tooltip>
      </TableCell>
    );
  };

  const routeJsx = (id, align, value, row) => {
    return <RouteJsx key={id} id={id} align={align} value={value} row={row} />;
  };

  const audioPlayerJsx = (id, align, value, row) => {
    return <AudioPlayerJsx key={id} id={id} align={align} value={value} row={row} />;
  };

  const actionJsx = (id, align, value, row) => {
    return <ActionJsx key={id} id={id} align={align} value={value} row={row} />;
  };

  const ttsContentJsx = (id, align, value, row) => {
    return <TtsContentJsx key={id} id={id} align={align} value={value} row={row} />;
  };
  const pttsContentJsx = (id, align, value, row) => {
    return <PttsContentJsx key={id} id={id} align={align} value={value} row={row} />;
  };

  const rejectionReasonJsx = (id, align, value, row) => {
    return (
      <TableCell
        key={id}
        align={align}
        sx={{
          color: 'grey.700',
          borderBottom: '0.5px dashed',
          borderColor: 'grey.300',
        }}
      >
        <Tooltip title={value}>{value?.length > 20 ? `${value.slice(0, 20)}...` : value || '--'}</Tooltip>
      </TableCell>
    );
  };

  const chipColors = {
    1000: { color: '#50AB64', backgroundColor: 'rgba(40, 167, 69, 0.20)' },
    1: { color: '#50AB64', backgroundColor: 'rgba(40, 167, 69, 0.20)' },
    A: { color: '#50AB64', backgroundColor: 'rgba(40, 167, 69, 0.20)' },
    D: { color: '#D19244', backgroundColor: 'rgba(209, 146, 68, 0.20)' },
    C: { color: '#50AB64', backgroundColor: 'rgba(40, 167, 69, 0.20)' },
    0: { color: '#D19244', backgroundColor: 'rgba(209, 146, 68, 0.20)' },
    2: { color: '#E2533F', backgroundColor: 'rgba(236, 64, 64, 0.20)' },
    104: { color: '#E2533F', backgroundColor: 'rgba(236, 64, 64, 0.20)' },
    NA: { color: '#E2533F', backgroundColor: 'rgba(236, 64, 64, 0.20)' },
    101: { color: '#50AB64', backgroundColor: 'rgba(40, 167, 69, 0.20)' },
    CG: { color: '#50AB64', backgroundColor: 'rgba(40, 167, 69, 0.20)' },
    100: { color: '#D19244', backgroundColor: 'rgba(209, 146, 68, 0.20)' },
    p: { color: '#D19244', backgroundColor: 'rgba(209, 146, 68, 0.20)' },
    102: { color: '#E2533F', backgroundColor: 'rgba(236, 64, 64, 0.20)' },
    O: { color: '#E2533F', backgroundColor: 'rgba(236, 64, 64, 0.20)' },
    BZ: { color: '#E2533F', backgroundColor: 'rgba(236, 64, 64, 0.20)' },
    BL: { color: '#E2533F', backgroundColor: 'rgba(236, 64, 64, 0.20)' },
  };

  const statusMapper = (value) => {
    const map = {
      100: 'Pending',
      1: 'Active',
      2: 'Rejected',
      0: 'Pending',
      101: 'Running',
      102: 'Pause',
      104: 'Stopped',
      1000: 'Complete',
      p: 'Pending',
      A: 'Answered',
      D: 'DND',
      NA: 'Not Answered',
      CG: 'Congestion',
      O: 'Other',
      C: 'Calling',
      BZ: 'Busy',
      BL: 'BlackListed',
    };
    if (map[value]) return map[value];
    return value;
  };

  const createStatusElement = (value, row) => {
    const statusChip = (value) => (
      <Chip
        label={statusMapper(value)}
        sx={{
          p: '2px 0px 2px 0px',
          height: 'auto',
          borderRadius: '5px',
          fontWeight: 500,
          '&:hover': {
            ...chipColors?.[value],
          },
          ...chipColors?.[value],
        }}
      />
    );

    const allStatus = {
      100: statusChip,
      1: statusChip,
      0: statusChip,
      2: statusChip,
      101: statusChip,
      102: statusChip,
      104: statusChip,
      1000: statusChip,
      p: statusChip,
      A: statusChip,
      D: statusChip,
      NA: statusChip,
      CG: statusChip,
      O: statusChip,
      C: statusChip,
      BZ: statusChip,
      BL: statusChip,
    };

    return allStatus[value] ? allStatus?.[value](value) : approveButton(row?.ivr_id);
  };

  const statusJsx = (id, align, value, row) => {
    return (
      <TableCell
        key={id}
        align={align}
        sx={{
          color: 'grey.700',
          borderBottom: '0.5px dashed',
          borderColor: 'grey.300',
        }}
      >
        {createStatusElement(value, row)}
      </TableCell>
    );
  };
  const reportStatusJsx = (id, align, value, row) => {
    let updatedValue = value;
    if (row?.status === 1 && value === 'p') updatedValue = 'C';

    return (
      <TableCell
        key={id}
        align={align}
        sx={{
          color: 'grey.700',
          borderBottom: '0.5px dashed',
          borderColor: 'grey.300',
        }}
      >
        {createStatusElement(updatedValue)}
      </TableCell>
    );
  };
  const typeMapper = {
    A: 'Assign',
    D: 'Deduct',
  };

  const typeJsx = (id, align, value) => (
    <TableCell
      key={id}
      align={align}
      sx={{
        color: 'grey.700',
        borderBottom: '0.5px dashed',
        borderColor: 'grey.300',
        background: 'transparent',
      }}
    >
      {value !== undefined ? typeMapper[value] : '--'}
    </TableCell>
  );

  const timestampFormatJsx = (id, align, value, ...other) => {
    const formattedDate = moment(value * 1000).format('D MMM, YYYY');
    console.log(formattedDate);

    return (
      <TableCell
        key={id}
        align={align}
        sx={{
          color: 'grey.700',
          borderBottom: '0.5px dashed',
          borderColor: 'grey.300',
        }}
      >
        <>
          <Box>{formattedDate}</Box>
        </>
      </TableCell>
    );
  };
  const campaignTypeJsx = (id, align, value) => (
    <TableCell
      key={id}
      align={align}
      sx={{
        color: 'grey.700',
        borderBottom: '0.5px dashed',
        borderColor: 'grey.300',
      }}
    >
      {value.toUpperCase() == 'API' ? 'API' : 'REG'}
    </TableCell>
  );

  const tableRowData = {
    create_date: dateFormatJsx,
    role: roleFormatJsx,
    status: reportStatusJsx,
    userType: userTypeJsx,
    type: typeJsx,
    announcementUrl: audioPlayerJsx,
    actions: actionJsx,
    route: routeJsx,
    used_module: usedModuleJsx,
    ttsContent: ttsContentJsx,
    rejectionReason: rejectionReasonJsx,
    pttsContent: pttsContentJsx,
    delete_date: timestampFormatJsx,
    campaign_type: campaignTypeJsx,
  };

  return (
    <Paper
      sx={{
        overflow: 'hidden',
        backgroundColor: 'grey.1000',
        borderRadius: '6px',
      }}
    >
      <TableFilterSection>{tableFilter}</TableFilterSection>

      <TableContainer sx={{ maxHeight: window.innerHeight - calculatedHeight }}>
        <Table stickyHeader aria-label="sticky table" size={size}>
          <TableHead
            sx={{
              position: 'sticky',
            }}
          >
            <TableRow>
              {columns.map(({ id, align, minWidth, label }) => (
                <TableCell
                  key={id}
                  align={align}
                  style={{ minWidth }}
                  sx={{
                    backgroundColor: 'grey.200',
                    color: 'grey.600',
                  }}
                >
                  {label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          {!loading ? (
            <TableBody>
              {rows.map((row) => (
                <TableRow hover role="checkbox" tabIndex={-1} key={row?.userId || row?.email}>
                  {columns.map(({ id, align }) => (tableRowData?.[id] || defaultRowJsx)(id, align, row[id], row))}
                </TableRow>
              ))}
            </TableBody>
          ) : (
            <TableBody>
              <TableRow hover role="checkbox" tabIndex={-1}>
                {columns.map(({ id, align }) => (
                  <TableCell
                    key={id}
                    align={align}
                    sx={{
                      color: 'grey.300',
                      borderBottom: '1px solid',
                      borderColor: 'grey.800',
                    }}
                  >
                    <CustomSkeleton variant={'text'} component={'h6'} width={'100%'} />
                  </TableCell>
                ))}
              </TableRow>
            </TableBody>
          )}
        </Table>
      </TableContainer>

      {count > 0 && (
        <TablePagination
          rowsPerPageOptions={[10, 25, 50, 100]}
          component="div"
          count={count}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          sx={{
            backgroundColor: 'grey.1000',
            color: 'grey.700',
          }}
        />
      )}

      {!(count || loading) && (
        <Box
          sx={{
            height: {
              xs: '480px',
              sm: '480px',
              md: '480px',
              lg: '480px',
              xl: '670px',
            },
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <NetworkError
            message={!error ? commonMessage?.noDataFound : commonMessage?.networkError}
            calculatedHeight={calculatedHeight}
          />
        </Box>
      )}
      {ActionModals && <ActionModals />}
    </Paper>
  );
};

PaginationTable.propTypes = {
  page: propTypes.number,
  setPage: propTypes.func.isRequired,
  rowsPerPage: propTypes.number,
  setRowsPerPage: propTypes.func.isRequired,
  setLoad: propTypes.func.isRequired,
  count: propTypes.number,
  error: propTypes.bool,
  loading: propTypes.bool,
  setLoading: propTypes.func,
  rows: propTypes.array.isRequired,
  columns: propTypes.array.isRequired,
  maxHeight: propTypes.number,
};
